
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line

/**
 * StopOutType enum
 */
class StopOutType {
  /**
   * Initialize enum with a given value
   * @param {StopOutType|number|Int64|UInt64=} value Enum value, defaults is 0
   * @constructor
   */
  constructor (value = 0) {
    if (value instanceof StopOutType) {
      this.value = value.value
    } else {
      this.value = value
    }
  }

  /**
   * Is this enum equal to other one?
   * @this {!StopOutType}
   * @param {!StopOutType} other Other enum
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof StopOutType)) {
      throw new TypeError('Instance of StopOutType is required!')
    }
    return this.value === other.value
  }

  /**
   * Get enum value
   * @this {!StopOutType}
   * @returns {!number|!Int64|!UInt64} Enum value
   */
  valueOf () {
    return this.value
  }

  /**
   * Convert enum to string
   * @this {!StopOutType}
   * @returns {!string} Enum value string
   */
  toString () {
    if (this.value === StopOutType.CLOSE_ALL.value) {
      return 'CLOSE_ALL'
    }
    if (this.value === StopOutType.CLOSE_MOST_LOSS.value) {
      return 'CLOSE_MOST_LOSS'
    }
    return '<unknown>'
  }

  /**
   * Inspect enum
   * @this {!StopOutType}
   * @returns {!string} Enum value string
   */
  [util.inspect.custom] () {
    return this.toString()
  }

  /**
   * Convert enum to JSON
   * @this {!StopOutType}
   * @returns {!number} Enum value for JSON
   */
  toJSON () {
    return this.value
  }

  /**
   * Create enum from object value
   * @param {!number} other Object value
   * @returns {!StopOutType} Created enum
   */
  static fromObject (other) {
    return new StopOutType(other)
  }
}

// noinspection PointlessArithmeticExpressionJS
StopOutType.CLOSE_ALL = new StopOutType(0 + 0)
// noinspection PointlessArithmeticExpressionJS
StopOutType.CLOSE_MOST_LOSS = new StopOutType(0 + 1)

export { StopOutType };

/**
 * Fast Binary Encoding StopOutType field model
 */
class FieldModelStopOutType extends fbe.FieldModel {
  /**
   * Get the field size
   * @this {!FieldModelStopOutType}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 1
  }

  /**
   * Get the value
   * @this {!FieldModelStopOutType}
   * @param {StopOutType=} defaults Default value, defaults is new StopOutType()
   * @returns {!StopOutType} Result value
   */
  get (defaults = new StopOutType()) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return defaults
    }

    return new StopOutType(this.readByte(this.fbeOffset))
  }

  /**
   * Set the value
   * @this {!FieldModelStopOutType}
   * @param {!StopOutType} value Value
   */
  set (value) {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return
    }

    this.writeByte(this.fbeOffset, value.value)
  }
}

export { FieldModelStopOutType };
